const innerHeight = require('ios-inner-height');

const html = document.getElementById('html');
const body = document.body;

const viewportHeight = innerHeight();
const headerHeight = document.querySelector('.main-header').offsetHeight;

const triggerToggleProgressOverview = document.querySelector('.js-progress-overview-toggle');
const progressOverviewContainer = document.querySelector('.progress-overview');

const progressOverview = document.querySelector('.progress-overview');
const progressOverviewTitle = document.querySelector('.progress-overview__title');

const learningContent = document.querySelector('.learning__content');

const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

// Progress overview on learning page
function ProgressOverview() {
    if (progressOverviewContainer) {
        // CLOSE ASIDE BY DEFAULT ON SMALL SCREENS
        const mq = window.matchMedia('(max-width: 1024px)');
        if (mq.matches) {
            progressOverviewContainer.classList.add('aside--closed');
        }

        // TOGGLE ASIDE ON CLICK
        triggerToggleProgressOverview.addEventListener('click', (e) => {
            e.preventDefault();

            progressOverviewContainer.classList.toggle('aside--closed');

            // FOR IPHONE: prevents scrolling of body while scrolling in aside (most of the times, i'm sorry)
            if (navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
                if (!progressOverviewContainer.classList.contains('aside--closed')) {
                    body.style.height = '100%';
                    body.style.overflow = 'visible';
                    html.classList.add('html--aside--open'); // Safari!
                } else {
                    body.style.height = '';
                    body.style.overflow = '';
                    html.classList.remove('html--aside--open'); // Safari!
                }
            }
        });

        // WHEN SCROLLING IN THE ASIDE, NO SCROLLING IN BODY ALLOWED (NOT FOR IE11 because no sticky there)
        if (!isIE11) {
            progressOverviewContainer.addEventListener('mouseenter', (e) => {
                e.preventDefault();

                body.classList.add('noscroll');
            });
            progressOverviewContainer.addEventListener('mouseleave', (e) => {
                e.preventDefault();

                body.classList.remove('noscroll');
            });
        }

        // CALCULATE ASIDE HEIGHT AND POSITION TITLE
        // ON WINDOW LOAD
        window.addEventListener('load', (e) => {
            e.preventDefault();

            calculateAside();
        });
        // ON SCROLL
        window.addEventListener('scroll', (e) => {
            e.preventDefault();

            calculateAside();
        });
    }
}

function calculateAside() {
    const pageOffsetTop = window.pageYOffset;
    const footerOffsetTop = document.querySelector('.main-footer').offsetTop; // on document load FF hasn't loaded everything yet and it will return a wrong offset

    const mainfooterHeight = document.querySelector('.main-footer').offsetHeight;
    const subfooterHeight = document.querySelector('.sub-footer').scrollHeight; // on document load subfooter isn't painted correct yet and will return a wrong offsetHeight
    const footerHeight = mainfooterHeight + subfooterHeight;

    const asideHeightHeaderInview = `calc(100vh - ${headerHeight}px + ${pageOffsetTop}px)`;
    const asideHeightFooterInview = `calc(${footerOffsetTop}px - ${pageOffsetTop}px)`;

    let learningContentHeight = learningContent.offsetHeight;
    learningContentHeight += parseInt(
        window.getComputedStyle(learningContent).getPropertyValue('margin-top'), 10
    );
    learningContentHeight += parseInt(
        window.getComputedStyle(learningContent).getPropertyValue('margin-bottom'), 10
    );

    // TITLE IN ASIDE FIXED WHEN HEADER IS SCROLLED OUT OF VIEW
    // --> fix for Safari repaint issues for sticky inside sticky
    if (pageOffsetTop >= headerHeight) {
        progressOverviewTitle.classList.add('fixed');// use classtoggle and don't insert styles inline -> prefix troubles with sticky
    } else {
        progressOverviewTitle.classList.remove('fixed');
    }

    // CALCULATE AVAILABLE HEIGHT FOR ASIDE
    // if content is less high then viewport - header - footer -> push footer down
    if (learningContentHeight <= viewportHeight - headerHeight - footerHeight) {
        progressOverview.style.height = `calc(100vh - ${headerHeight}px - ${footerHeight}px)`;
    // if content is less high then viewport - header but high enough to fill the viewport -> aside = height of content
    } else if (learningContentHeight <= viewportHeight - headerHeight) {
        progressOverview.style.height = `${learningContentHeight}px`;
    // if header in view
    } else if (pageOffsetTop <= headerHeight) {
        // console.log('header in view');
        progressOverview.style.height = asideHeightHeaderInview;
    // else if footer in view
    } else if ((pageOffsetTop + viewportHeight) > footerOffsetTop) {
        // console.log('footer in view');
        progressOverview.style.height = asideHeightFooterInview;
    // everything in between
    } else {
        // console.log('in between');
        progressOverview.style.height = '100vh';
    }
}


export default ProgressOverview;



// WEBPACK FOOTER //
// ./src/Will/WebsiteBundle/Resources/ui/js/ProgressOverview.js